import React from 'react';
import { Typography } from 'fronton-react';

export const getFormSubheading = (isMobile: boolean | null, isHaveComplimentaryProduct: boolean) => (
  <Typography size="body_long" variant={isMobile ? 's' : 'l'} color="text-primary">
    Рассчитаем количество товара
    {isHaveComplimentaryProduct ? `, подберем инструменты и расходники` : ''}
  </Typography>
);
